import React from "react";
import { AnimatePresence } from "framer-motion";
import {
  SpotlightSection,
  SpotlightContainer,
  HeroImageContainer,
  HeroImage,
  GradientPlaceholder,
  SpotlightDetails,
  ProjectTitle,
  ProjectDescription,
  TechTagsRow,
  TechTag,
  LearningTargetsContainer,
  LearningTargetLabel,
  LearningTargetRow,
  ViewProjectLink,
} from "./styles";

const spotlightVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.4, ease: "easeOut" },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: { duration: 0.25 },
  },
};

const SpotlightView = ({ project }) => {
  if (!project) return null;

  return (
    <SpotlightSection tint={project.gradient.accent}>
      <AnimatePresence exitBeforeEnter>
        <SpotlightContainer
          key={project.id}
          variants={spotlightVariants}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <HeroImageContainer>
            {project.image ? (
              <HeroImage
                src={project.image}
                alt={project.title}
                accent={project.gradient.accent}
              />
            ) : (
              <GradientPlaceholder
                gradient={project.gradient.background}
                accent={project.gradient.accent}
              >
                {project.title.charAt(0)}
              </GradientPlaceholder>
            )}
          </HeroImageContainer>

          <SpotlightDetails>
            <ProjectTitle
              from={project.gradient.from}
              to={project.gradient.to}
            >
              {project.title}
            </ProjectTitle>

            <ProjectDescription>{project.description}</ProjectDescription>

            <TechTagsRow>
              {project.techTags.map((tag) => (
                <TechTag key={tag} accent={project.gradient.accent}>
                  {tag}
                </TechTag>
              ))}
            </TechTagsRow>

            {project.learningTargets && project.learningTargets.length > 0 && (
              <LearningTargetsContainer>
                <LearningTargetLabel>Learning Targets</LearningTargetLabel>
                {project.learningTargets.map((lt) => (
                  <LearningTargetRow key={lt.target}>
                    {lt.target} &mdash; {lt.desc}
                  </LearningTargetRow>
                ))}
              </LearningTargetsContainer>
            )}

            {project.link && (
              <ViewProjectLink
                href={project.link}
                target="_blank"
                rel="noreferrer"
                from={project.gradient.from}
                to={project.gradient.to}
              >
                View Project &rarr;
              </ViewProjectLink>
            )}
          </SpotlightDetails>
        </SpotlightContainer>
      </AnimatePresence>
    </SpotlightSection>
  );
};

export default SpotlightView;
